export const isProduction = () => {
  return import.meta.env?.PROD;
};
